import { useMemo, useState } from "react";
import { Container } from "reactstrap";

import DropdownOptionWithIcon from "../../../../components/Menus/DropdownOptionWithIcon";
import AppTablePagination from "../../../../components/AppTable/AppTablePagination";
import PopoverDropdownMenu from "../../../../components/Menus/PopoverDropdownMenu";
import AppPageHeader from "../../../../components/Headers/AppPageHeader";
import useDeleteOrphanCollection from "./useDeleteOrphanCollection";
import AppEmptyState from "../../../../elements/AppEmptyState";
import ListItem from "../../../../components/CRM/ListItem";
import useOrphanCollections from "./useOrphanCollections";
import { AppConfirm } from "../../../../utils/PopupUtil";

export default function OrphanCollections() {
  const [query, setQuery] = useState({ Pagination: { Count: 25, Page: 1 } });
  const tenantID = useMemo(() => {
    if (!window) return undefined;

    return window.location.pathname.startsWith("/supportal")
      ? sessionStorage.getItem("LastVisitedTenant") ?? undefined
      : undefined;
  }, [window]);
  const { collections, pagination, isLoading } = useOrphanCollections({
    paginaton: query.Pagination,
    tenantID: tenantID,
  });

  return (
    <>
      <Container fluid>
        <AppPageHeader
          title="Orphan Collections"
          description="Manage the orphan collections in the system"
        />
        {isLoading ? (
          <div className="m-2" style={{ height: "150px" }}>
            <ListItem loading />
            <ListItem loading />
          </div>
        ) : (
          <div>
            {!!collections && collections?.length ? (
              <>
                {collections.map((collection) => {
                  return (
                    <ListItem
                      icon="mdi mdi-database-alert"
                      title={collection.name}
                      options={
                        <OrphanOptions
                          collectionName={collection.name}
                          tenantID={tenantID}
                        />
                      }
                    />
                  );
                })}
              </>
            ) : (
              <AppEmptyState
                title="No Orphan Collections."
                description="Orphane collections were not found."
              />
            )}
          </div>
        )}

        <AppTablePagination
          records={collections}
          pagination={pagination}
          query={query}
          setquery={setQuery}
          loading={isLoading}
        />
      </Container>
    </>
  );
}

function OrphanOptions({
  collectionName,
  tenantID,
}: {
  collectionName: string;
  tenantID?: string;
}) {
  const { deleteOrphanCollection, deleteLoading } = useDeleteOrphanCollection();

  const onDelete = async () => {
    const result = await AppConfirm({
      title: "Confirm Deletion",
      text: `Are you sure you want to delete ${collectionName} permanently from the database?`,
      confirmButtonText: "Delete",
      icon: "error",
      confirmButtonColor: "var(--danger)",
    });

    if (!result.isConfirmed) return;

    deleteOrphanCollection({ collectionName, tenantID });
  };

  return (
    <PopoverDropdownMenu>
      <DropdownOptionWithIcon
        name="Delete"
        icon="mdi mdi-delete"
        onClick={onDelete}
        disabled={deleteLoading}
      />
    </PopoverDropdownMenu>
  );
}
